import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Modal } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useNavigate } from 'react-router-dom';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { triggerRelaunchStep } from '../helpers/relaunchStepHelpers';
import styles from './ExistingIntroducerModal.module.css';

type TProps = {
  triggerDashboardTour: () => void;
  showModal: boolean;
  closeModal: () => void;
};

export const ExistingIntroducerModal = ({
  triggerDashboardTour,
  showModal,
  closeModal,
}: TProps) => {
  const navigate = useNavigate();
  const { introducerId } = useIntroducerData();

  const trackTutorialStarted = (tourName: string, ctaText: string) => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': ctaText,
      'CTA type': 'Existing introducer modal',
    });
    tracking.ampli.tutorialStarted({
      ...getAmplitudeDefaultEventProperties(),
      name: tourName,
    });
  };

  const onMaybeLaterClick = () => {
    triggerRelaunchStep({
      introducerId,
      tutorial: 'existing_introducer_opt_in',
    });
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Maybe later',
      'CTA type': 'Existing introducer modal',
    });
    closeModal();
  };

  return (
    <Modal
      className={styles.modal}
      isOpen={showModal}
      onClose={closeModal}
      title={t`Portal tours are here! ✨`}
    >
      <p className={styles.text}>
        <Trans>
          Get the most out of our Portal and take a quick tour of our top
          features - the dashboard, and calculator.
        </Trans>
      </p>
      <div className={styles.triggerTourButtons}>
        <Button
          className={styles.triggerTourButton}
          onClick={() => {
            closeModal();
            trackTutorialStarted('Dashboard', 'Dashboard tour');
            triggerDashboardTour();
          }}
        >
          <Trans>Dashboard tour</Trans>
        </Button>
        <Button
          className={styles.triggerTourButton}
          onClick={() => {
            closeModal();
            trackTutorialStarted('Calculator', 'Calculator tour');
            navigate(PATH_NAMES.calculator({ tourType: 'auto' }));
          }}
        >
          <Trans>Calculator tour</Trans>
        </Button>
      </div>
      <Button
        className={styles.secondaryButton}
        variant="tertiary"
        onClick={onMaybeLaterClick}
      >
        <Trans>Maybe later</Trans>
      </Button>
    </Modal>
  );
};
